<h2>Service Mapping</h2>

<div class="px-2 py-3 contents h-full max-h-80" *ngIf="isLoadServiceMappingGridDataSource">
    <div class="flex pb-4 justify-start">
        <dx-check-box [value]="false" text="Include deactivated Service Mapping items" class="pr-2" (onValueChanged)="extraFilteringOptionsChange('Active', $event)"></dx-check-box>
    </div>
    <div class="mapping-grid-container">
        <dx-data-grid #serviceMappingLightDataGrid id="gridContainer"
                      [allowColumnResizing]="true"
                      [columnResizingMode]="'widget'"
                      [allowColumnReordering]="true"
                      [dataSource]="serviceMappingLightGridDataSource"
                      [showBorders]="true"
                      [columnAutoWidth]="true"
                      [remoteOperations]="true"
                      [masterDetail]="{ enabled: true, template: 'detail' }"
                      [hoverStateEnabled]="true"
                      [cacheEnabled]="false"
                      [(selectedRowKeys)]="serviceMappingLightGridSelectedRowMap"
                      (onRowExpanding)="onRowExpanding($event)"
                      (onSelectionChanged)="selectionChangedHandler()"
                      (onContextMenuPreparing)="serviceMappingDataGridContextMenu($event)"
                      (onContentReady)="onReady($event)"
                      keyExpr="`ServiceAndProductMappingId`">
            <dxo-state-storing
                    [enabled]="true"
                    type="custom"
                    [customLoad]="loadMappingState"
                    [customSave]="saveMappingState">
            </dxo-state-storing>
            <dxo-load-panel
                    [enabled]="false"
                    shadingColor="rgba(0,0,0,0.4)"
                    [showIndicator]="true"
                    [showPane]="true"
                    [shading]="true">
            </dxo-load-panel>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-pager
                    [visible]="true"
                    [allowedPageSizes]="[5, 10, 25, 50, 100]"
                    displayMode="compact"
                    [showPageSizeSelector]="true"
                    [showNavigationButtons]="false"
            >
            </dxo-pager>
            <dxo-sorting mode="single"></dxo-sorting>
            <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>

            <dxi-column dataField="ServiceAndProductMappingId" [width]="140" caption="Source Mapping Id" [customizeText]="customizeServiceMappingId" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column caption="Action" cellTemplate="action" [width]="90" [allowHeaderFiltering]="false" alignment="center"></dxi-column>
            <dxi-column caption="Source Data - Category and Brand">
                <dxi-column dataField="SourceCategory" caption="Category" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="SourceSubcategory" caption="Subcategory" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="SourceDescription" caption="Description" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="SourceBrand" caption="Brand" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="SourceSubBrand" caption="Sub-brand" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="SourceCompany" caption="Company" [allowHeaderFiltering]="false"></dxi-column>
            </dxi-column>
            <dxi-column caption="Data Auditing">
                <dxi-column dataField="CreatedOn" format="d/M/yyyy, HH:mm" dataType="datetime" caption="Created on" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="createdOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created by">
                    <dxo-header-filter [dataSource]="createdByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified by">
                    <dxo-header-filter [dataSource]="modifiedByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedOn" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="modifiedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed by">
                    <dxo-header-filter [dataSource]="reviewedByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedOn" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="reviewedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>

            <dxi-column dataField="MappingModeName" caption="Mapping Mode Name" [allowHeaderFiltering]="false" [allowFiltering]="false">
            </dxi-column>
            <dxi-column dataField="MappingModeId" caption="Mapping Mode" [alignment]="'left'">
                <dxo-header-filter [dataSource]="mappingModeNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="MappingAssignedToUserFullNameSortableOrPrincipalName" caption="Mapping Assigned to">
                <dxo-header-filter [dataSource]="mappingAssignedToHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="Active" caption="Is Active" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column caption="Mapped To">
                <dxi-column dataField="ServiceMasterId"></dxi-column>
                <dxi-column dataField="Definition" caption="Definition" [allowHeaderFiltering]="false">
                    <dxo-header-filter [dataSource]="definitionHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SegmentId" caption="Segment ID">
                    <dxo-header-filter [dataSource]="segmentIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SegmentName" caption="Segment Name">
                    <dxo-header-filter [dataSource]="segmentNameMappingHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ServiceTypeId" caption="Service Type ID">
                    <dxo-header-filter [dataSource]="serviceTypeIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ServiceTypeName" caption="Service Type Name">
                    <dxo-header-filter [dataSource]="serviceTypeMappingNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SubSegmentId" caption="Sub-Segment ID" [allowHeaderFiltering]="false">
                    <dxo-header-filter [dataSource]="subSegmentIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SubSegmentName" caption="Sub-Segment Name">
                    <dxo-header-filter [dataSource]="subSegmentMappingNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="RelatedTerms" caption="Related Terms">
                    <dxo-header-filter [dataSource]="relatedTermsMappingHeaderDataSource"></dxo-header-filter>
                </dxi-column>

                <dxi-column dataField="MappingPriority" caption="Mapping Priority">
                    <dxo-header-filter [dataSource]="mappingPriorityHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>


            <div *dxTemplate="let action of 'action'">
                <dx-button
                        class="mr-1"
                        icon="fas fa-sign-in-alt fa-1x"
                        hint="Move to Product"
                        (onClick)="mapAsProduct()"></dx-button>
                <dx-button
                        *ngIf="currentUser.UserRoleId > 1 && !action?.data?.Active"
                        icon="fas fa-trash-restore fa-1x"
                        hint="Activate"
                        (onClick)="reactivate(action?.data?.ServiceAndProductMappingId)"></dx-button>
                <dx-button
                        *ngIf="currentUser.UserRoleId > 1 && action?.data?.Active"
                        icon="fas fa-trash-alt fa-1x"
                        hint="Deactivate"
                        (onClick)="deactivate(action?.data?.ServiceAndProductMappingId)"></dx-button>
            </div>

            <div *dxTemplate="let data of 'detail'">
                <div class="master-detail-caption"></div>
                <app-transaction-detail [key]="data.key"></app-transaction-detail>
            </div>
            <dxo-paging [pageSize]="5"></dxo-paging>
        </dx-data-grid>
    </div>
</div>

<div class="py-2" *ngIf="isLoadServiceMasterGridDataSource">
    <div dragula="HANDLES2" id="right">
        <div class="mapping-grid-container shadow-lg mt-2">
            <span class="handle"><i class="fa fa-arrows" aria-hidden="true"></i></span>
            <div class="py-2 h-full">
                <dx-data-grid
                  [allowColumnResizing]="true"
                  [columnResizingMode]="'widget'"
                  [allowColumnReordering]="true"
                  [dataSource]="serviceMappingToMasterGridDataSource"
                  [showBorders]="true"
                  [columnAutoWidth]="true"
                  [cacheEnabled]="false"
                  keyExpr="CurrentMappingModeId">
                  <dxo-load-panel
                    [enabled]="false"
                    shadingColor="rgba(0,0,0,0.4)"
                    [showIndicator]="true"
                    [showPane]="true"
                    [shading]="true">
                  </dxo-load-panel>
                    <dxi-column dataField="MappingSource" caption="Mappings"></dxi-column>
                    <dxi-column caption="Action" cellTemplate="action" alignment="center"></dxi-column>
                    <dxi-column dataField="ServiceMasterId" caption="Service Master Id" [customizeText]="customizeServiceMasterId"></dxi-column>
                    <dxi-column dataField="ServiceTypeName" caption="Service Type"></dxi-column>
                    <dxi-column dataField="SegmentName" caption="Segment"></dxi-column>
                    <dxi-column dataField="SubSegmentName" caption="Sub-segment"></dxi-column>
                    <dxi-column dataField="Definition" caption="Definition"></dxi-column>
                    <dxi-column dataField="RelatedTerms" caption="Related Terms"></dxi-column>
                    <dxi-column dataField="MappingModeName" caption="Mapping Mode"></dxi-column>

                    <div *dxTemplate="let action of 'action'">
                        <dx-button
                            id="btnOmit"
                            *ngIf="action?.data?.Ranking == -1"
                            class="mr-1"
                            icon="fas fa-ban fa-1x"
                            hint="Omit"
                            [disabled]="action?.data?.CurrentMappingModeId == 3"
                            (onClick)="omit()"></dx-button>
                        <dx-button
                            id="btnSave"
                            *ngIf="action?.data?.Ranking == -1"
                            class="mr-1"
                            icon="far fa-bookmark fa-1x"
                            hint="Save"
                            [disabled]="action?.data?.CurrentMappingModeId == 2"
                            (onClick)="save()"></dx-button>
                        <dx-button
                            id="btnAccept"
                            *ngIf="action?.data?.Ranking == -1 && !(serviceMappingLightGridSelectedRowData.ModifiedByUserId > 0 || (action?.data?.CurrentMappingModeId == 0 && action?.data?.CurrentServiceMasterId == 0))"
                            class="mr-1"
                            icon="fa fa-check fa-1x"
                            hint="Accept"
                            (onClick)="accept()"></dx-button>
                        <dx-button
                            id="btnReview"
                            *ngIf="
                                action?.data?.Ranking == -1 &&
                                currentUser.UserRoleId > 1 &&
                                serviceMappingLightGridSelectedRowData.MappingModeId !== 0 &&
                                serviceMappingLightGridSelectedRowData.ModifiedByUserId > 0 &&
                                serviceMappingLightGridSelectedRowData.ModifiedByUserId !== currentUser.UserId &&
                                serviceMappingLightGridSelectedRowData.ReviewedByUserId == -1"
                            icon="fas fa-check-double fa-1x"
                            hint="Review"
                            (onClick)="review()"></dx-button>
                        <dx-button
                            id="btnAcceptOmit"
                            *ngIf="action?.data?.Ranking >= 0 && action?.data?.MappingModeId == 3 && (action?.data?.Ranking > 0 || action?.data?.IsValidBarcode) && action?.data?.CurrentMappingModeId === 3"
                            class="mr-1"
                            icon="fas fa-ban fa-1x"
                            hint="Accept Omit"
                            (onClick)="omit()"></dx-button>
                        <dx-button
                            id="btnAcceptSave"
                            *ngIf="action?.data?.Ranking >= 0 && action?.data?.MappingModeId == 2 && (action?.data?.Ranking > 0 || action?.data?.IsValidBarcode) && action?.data?.CurrentMappingModeId == 2"
                            class="mr-1"
                            icon="far fa-bookmark fa-1x"
                            hint="Accept Save"
                            (onClick)="save()"></dx-button>
                        <dx-button
                            id="btnAcceptMapping"
                            *ngIf="action?.data?.Ranking >= 0 && action?.data?.MappingModeId == 1 && (action?.data?.ServiceMasterId != 0) && action?.data?.CurrentServiceMasterId == action?.data?.ServiceMasterId"
                            class="mr-1"
                            icon="fas fa-map-marker-alt fa-1x"
                            hint="Accept Mapping"
                            (onClick)="acceptMapping()"></dx-button>
                    </div>
                </dx-data-grid>
            </div>
        </div>
        <div class="mapping-grid-container shadow-lg mt-2">
            <span class="handle"><i class="fa fa-arrows" aria-hidden="true"></i></span>
            <div  class="py-2 h-full">
                <dx-data-grid
                    #serviceMasterExpandedDataGrid
                    id="gridContainer2"
                    [allowColumnResizing]="true"
                    [columnResizingMode]="'widget'"
                    [allowColumnReordering]="true"
                    [dataSource]="serviceMasterExpandedDataSource"
                    [showBorders]="true"
                    [columnAutoWidth]="true"
                    [remoteOperations]="true"
                    [hoverStateEnabled]="true"
                    [cacheEnabled]="false"
                    [(selectedRowKeys)]="serviceMasterExpandedSelectedRowMap"
                    (onContextMenuPreparing)="serviceMasterDataGridContextMenu($event)"
                    (onSelectionChanged)="serviceMasterExpandedSelectionChangedHandler()"
                    keyExpr="ServiceMasterId">
                    <dxo-state-storing
                            [enabled]="true"
                            type="custom"
                            [customLoad]="loadMasterState"
                            [customSave]="saveMasterState">
                    </dxo-state-storing>
                    <dxo-load-panel
                        [enabled]="false"
                        shadingColor="rgba(0,0,0,0.4)"
                        [showIndicator]="true"
                        [showPane]="true"
                        [shading]="true">
                    </dxo-load-panel>
                    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-pager
                        [visible]="true"
                        [allowedPageSizes]="[5, 10, 25, 50, 100]"
                        displayMode="compact"
                        [showPageSizeSelector]="true"
                        [showNavigationButtons]="false"
                    >
                    </dxo-pager>
                    <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
                    <dxo-selection mode="single"></dxo-selection>
                    <!-- <dxo-sorting mode="none"></dxo-sorting> -->
                    <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>

                    <dxi-column dataField="ServiceMasterId" [allowHeaderFiltering]="false" [customizeText]="customizeServiceMasterId"></dxi-column>
                    <dxi-column caption="Action" [allowHeaderFiltering]="false" cellTemplate="action" alignment="center"></dxi-column>
                    <dxi-column dataField="ServiceTypeName" caption="Service Type">
                        <dxo-header-filter [dataSource]="serviceTypeNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="SegmentName" caption="Segment">
                        <dxo-header-filter [dataSource]="segmentNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="SubSegmentName" caption="Sub-segment">
                        <dxo-header-filter [dataSource]="subSegmentNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="Definition">
                        <dxo-header-filter [dataSource]="definitionHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="RelatedTerms" caption="Related Terms">
                        <dxo-header-filter [dataSource]="relatedTermsHeaderDataSource"></dxo-header-filter>
                    </dxi-column>

                    <div *dxTemplate="let action of 'action'">
                        <dx-button
                            icon="fas fa-map-marker-alt fa-1x"
                            hint="Map"
                            (onClick)="map(action?.data?.ServiceMasterId)"></dx-button>
                    </div>
                    <dxo-paging [pageSize]="5"></dxo-paging>
                    <!-- <dxo-pager
                        [showPageSizeSelector]="true"
                        [allowedPageSizes]="[8, 12, 20]"
                    ></dxo-pager> -->
                </dx-data-grid>
            </div>
        </div>
    </div>
</div>
